import React from 'react'
import { InstantSearch } from './instant_search';
import { AuthInteract } from './auth_interact';
import { MobileMenu } from './mobile_menu';
import { Guest } from './guest'; 
import { menus, menusGuest, user } from './mock'

export const Navbar = () =>{

    return (
        <React.Fragment>
        <div className="header_wrapper">
            <header id="navigation">
                <div className="logo">
                    <a href="/"> NOVA </a>
                        <InstantSearch />
                </div>

                <ul className="menu">
                    {
                       (true ? menus : menusGuest).map((menu,i)=>(
                            <li key={i} className={`${ menu.url === '/projects' && 'active'}`} >
                                <a href={menu.url || '#'} >
                                    <a href="/">
                                        {menu.symbol}
                                        <p>{menu.title}</p>
                                       
                                    </a>
                                </a>
                            </li>
                        ))
                    }
                </ul>
              
                <React.Fragment>
                    { false ? <AuthInteract user={user} /> : <Guest /> }
                </React.Fragment>
                <MobileMenu isAuth={true} avatar={user.avatar}/>
            </header>   
        </div>
        </React.Fragment>
    )
}

export default Navbar;



